import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

class DeleteAssetModal extends React.Component {
    render() {
        const { show, asset, onClose, onDelete } = this.props;
        const { embedURL } = asset;

        if (!show) {
            return null;
        }

        return (
            <React.Fragment>
                <Dialog open={true} onClose={onClose}>
                    <DialogTitle>Are you sure?</DialogTitle>
                    <DialogContent>
                        <div>
                            <Typography variant="body1">
                                Deleting an asset is irreversible. Make a copy
                                of the asset if you intent to keep it safe.
                            </Typography>
                            {embedURL && (
                                <Typography variant="body1" color="secondary">
                                    This asset is published. Links to it will no
                                    longer work for users!
                                </Typography>
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>CANCEL</Button>

                        <Button
                            onClick={() => {
                                onDelete(asset);
                                onClose();
                            }}
                            color="secondary"
                            variant="contained"
                        >
                            DELETE ASSET
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

DeleteAssetModal.propTypes = {
    asset: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

DeleteAssetModal.defaultProps = {
    show: false,
};

export default DeleteAssetModal;



// WEBPACK FOOTER //
// ./src/components/modals/DeleteAssetModal.js